import { iconLibrary } from '@clover/web-lib-core/dist/components/CoreIcon/iconLibrary';
import styles from './styles.module.scss';

export enum NotificationVariant {
  Red,
  Yellow,
  Blue,
  Green,
}

export interface NotificationProperties {
  closeable?: boolean;
  closeTimer?: number | false; //If false, the notification will not auto close
  containerWidth?: number; // container width may be needed in case fixedPosition is true
  fixedPosition?: boolean;
  gutterBottom?: boolean;
}

export type NotificationData = {
  body?: string;
  variant: NotificationVariant;
  title: string;
};

export const Notifications: Record<
  NotificationVariant,
  {
    class: string;
    icon: keyof typeof iconLibrary;
  }
> = {
  [NotificationVariant.Red]: {
    class: styles.red,
    icon: 'error',
  },
  [NotificationVariant.Yellow]: {
    class: styles.yellow,
    icon: 'warning',
  },
  [NotificationVariant.Green]: {
    class: styles.green,
    icon: 'check-circle',
  },
  [NotificationVariant.Blue]: {
    class: styles.blue,
    icon: 'info',
  },
};
